<template>
    <div class="filter-container">
      <div class="fechas-container">
        <label>Desde: 
          <input class="filter-date" name="init-date" v-model="form.startDate" type="date" @change="getFilter()">
        </label>
        <div class="end-date"><label>Hasta: 
          <input class="filter-date" name="end-date" v-model="form.endDate" type="date" @change="getFilter()">
        </label>
      </div>
      </div>
      <div class="fechas-container">
        <label class="filter-string">Filtrar por palabras: <input class="filter-string" name="filter-string" v-model="form.filter" type="text" @keyup="getFilter()"></label>
      </div>
      <!-- <p style="margin-top: 1.5rem;">Resultados Mostrados: <span class="resultados">{{campaign_datas_filtered.length}}</span></p> -->
      <div class="button-container"><button class="new-button" @click="deleteFilters()">Borrar Filtros</button></div>
    </div>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex'
  import {getData} from './../../services/api'

  export default {
    name: 'panelFilter',
    data: function () {
        return {
          form: {
                startDate: '',
                endDate: '',
                filter: ''
          }
        }
    },
    computed: {
      ...mapGetters([
        'sonarsCampaignsList',
        'bathymetryCampaignsList',
        'mosaicsCampaignsList'
        ]),
        ...mapGetters(
            "map_params",{
                campaign_datas_filtered: 'campaign_datas_filtered',
                campaign_datas: 'campaign_datas'
            }
        ),
        ...mapGetters(['isLayerMosaicsVisible','isLayerBathymetryVisible','isLayerSonarsVisible']),
        campaign_datas_filtered: {
            set (selected_campaign) { this.$store.dispatch('map_params/change_campaign_datas_filtered', selected_campaign); },
            get () { return this.$store.state.map_params.campaign_datas_filtered}
        },

        mosaicsCampaignsListFiltered: {
            set (campaignsList) { this.$store.dispatch('changeMosaicsCampaignsListFiltered', {mosaicsCampaignsListFiltered: campaignsList}); },
            get () { return this.$store.state.mapLayers.layerMosaics.mosaicsCampaignsListFiltered }
        },
        sonarsCampaignsListFiltered: {
          set (campaignsList) { this.$store.dispatch('changeSonarsCampaignsListFiltered', {sonarsCampaignsListFiltered: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerSonars.sonarsCampaignsListFiltered }
        },
        bathymetryCampaignsListFiltered: {
          set (campaignsList) { this.$store.dispatch('changeBathymetryCampaignsListFiltered', {bathymetryCampaignsListFiltered: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaignsListFiltered }
      }
    },
    mounted () {
        this.getCampaignDatas()
    },
    methods: {
        getCampaignDatas: function () {
            this.$store.dispatch('map_params/getCampaignDatas')
        },

        deleteFilters: function() {
          this.from.startDate = null,
          this.from.endDate = null,
          this.from.filter = ""
          this.filter();
        },
        getFilter: function (){
          if (this.isLayerMosaicsVisible) this.getFilteredMosaics() 
          if (this.isLayerBathymetryVisible) this.getFilteredBathymetry() 
          if (this.isLayerSonarsVisible) this.getFilteredSonars() 
        },

        getFilteredMosaics: function () {
            var start = '2000-01-01'
            var end = '2200-01-01'
            var campFilter = 'no filter'
            if(this.form.startDate != '') start = this.form.startDate
            if(this.form.endDate != '') end = this.form.endDate
            if(this.form.filter != '') campFilter = this.form.filter
            let start_date = Date.parse(start)
            let end_date = Date.parse(end)

            this.mosaicsCampaignsListFiltered = this.mosaicsCampaignsList.filter(function(obj) {
              let campaign_start = Date.parse(obj.date);
              let campaign_end = Date.parse(obj.mosaicCampaignData[obj.mosaicCampaignData.length -1].date);

              const dateInRange = campaign_start >= start_date && campaign_end <= end_date
              let campStringFilter = true
              if(campFilter != 'no filter') 
                campStringFilter = obj.name.includes(campFilter) || obj.code.includes(campFilter) || obj.abstract.includes(campFilter) || obj.description.includes(campFilter) || obj.location.includes(campFilter) || obj.goal.includes(campFilter)
      
            return dateInRange && campStringFilter;
        })
        },

        getFilteredBathymetry: function () {
          var start = '2000-01-01'
          var end = '2200-01-01'
          var campFilter = 'no filter'
          if(this.form.startDate != '') start = this.form.startDate
          if(this.form.endDate != '') end = this.form.endDate
          if(this.form.filter != '') campFilter = this.form.filter
          let start_date = Date.parse(start)
          let end_date = Date.parse(end)
         
          this.bathymetryCampaignsListFiltered = this.bathymetryCampaignsList.filter(function(obj) {
            let campaign_start = Date.parse(obj.date);
            let campaign_end = Date.parse(obj.bathymetryCampaignData[obj.bathymetryCampaignData.length -1].date);

            const dateInRange = campaign_start >= start_date && campaign_end <= end_date
            let campStringFilter = true
            if(campFilter != 'no filter') 
              campStringFilter = obj.name.includes(campFilter) || obj.code.includes(campFilter) || obj.abstract.includes(campFilter) || obj.description.includes(campFilter) || obj.location.includes(campFilter) || obj.goal.includes(campFilter)
    
          return dateInRange && campStringFilter;
        })
      },
      getFilteredSonars: function () {
        var start = '2000-01-01'
        var end = '2200-01-01'
        var campFilter = 'no filter'

        if(this.form.startDate != '') start = this.form.startDate
        if(this.form.endDate != '') end = this.form.endDate
        if(this.form.filter != '') campFilter = this.form.filter
        let start_date = Date.parse(start)
        let end_date = Date.parse(end)

        this.sonarsCampaignsListFiltered = this.sonarsCampaignsList.filter(function(obj) {
          let campaign_start = Date.parse(obj.date);
          let campaign_end = Date.parse(obj.sonarCampaignData[obj.sonarCampaignData.length -1].date);

          const dateInRange = campaign_start >= start_date && campaign_end <= end_date
          let campStringFilter = true
          if(campFilter != 'no filter') 
            campStringFilter = obj.name.includes(campFilter) || obj.code.includes(campFilter) || obj.abstract.includes(campFilter) || obj.description.includes(campFilter) || obj.location.includes(campFilter) || obj.goal.includes(campFilter)
          
        return dateInRange && campStringFilter;
        })
      }
    }
  }
</script>

<style scoped>
.filter-container{
  margin: .5rem 1rem 0 1rem;
  overflow: hidden;
}
.filter-title {
  font-weight: bold;
  color: #447998;
  font-size: 0.8rem;
}
.filter-blue {
  color: #447998;
}

.panel-text-section-dark{
  color: #447998;
  font-size: 0.9rem;
  font-weight: bold;
}

.fechas-container{
  display: flex;
}

input {
  display: inline-block;
  width: 150px;
  top: 0.1em;
  color: #447998;
  border: 1px solid #447998;
  border-radius: 5px;
}

label {
  display: inline-block;
  width: 6em;
  margin-right: 0.5em;
  padding-top: 0.5em;
}

.end-date {
  margin-left: 60px;
}

.filter-string {
  width: 250px;
}

.resultados{
  color: #447998;
  font-weight: bold;
}

.button-container{
  padding: 20px;
  display: flex;
  float: right;
}

.new-button {
  background: #cc6b6b;
  font-size: 10px;
  color: #ffffff;
  height: 20px;
  border-radius: 20px;
  border: 1px solid #c95959;
  cursor: pointer;
  font-weight: 400;
  transition: 0.1s;
  opacity: 0.5;
}
.new-button:hover {
    background: #c95959;
    transform: scale(1.1);
    opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/map/panelFilter.vue